import React, { createContext, useState, ReactNode } from "react";

interface PDFContextType {
  selectedClauses: string[];
  currentPage: number;
  goToPage: (pageNumber: number) => void;
  selectClauseTags: (clauseId: string[]) => void;
  deselectClauseTags: (clauseId: string[]) => void;
}

const PDFContext = createContext<PDFContextType | undefined>(undefined);

interface PDFProviderProps {
  children: ReactNode;
}

export const PDFProvider: React.FC<PDFProviderProps> = ({ children }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedClauses, setSelectedClauses] = useState<string[]>([]);

  const selectClauseTags = (clauseIds: string[]): void => {
    const newSet = new Set([...selectedClauses, ...clauseIds]) // use set to dedupe
    setSelectedClauses([...newSet]);
  };

  const deselectClauseTags = (clauseIds: string[]): void => {
    setSelectedClauses(prev => prev.filter(c => !clauseIds.includes(c)))
  };

  const goToPage = (pageNumber: number): void => {
    setCurrentPage(pageNumber);
  };

  const value: PDFContextType = {
    selectedClauses,
    currentPage,
    goToPage,
    selectClauseTags,
    deselectClauseTags,
  };

  return <PDFContext.Provider value={value}>{children}</PDFContext.Provider>;
};

export { PDFContext };
